module.exports = __webpack_public_path__ + "static/blog-thumb-1-a9347727aa544cfa84a0441e2df47238.jpg";